export default {
  relativeTitle: {
    en: 'Okay, final deal: get 25%<br />OFF for a whole year!',
  },
  absoluteTitle: {
    en: 'Final deal: just $11.25/month for a year',
  },
  text: {
    en: 'If you sign on for a full year membership, we\'ll<br />take 25% off your monthly bill. <span class="bold">You save $44.40</span>',
  },
  accept: {
    en: 'Take this deal',
  },
  cancel: {
    en: 'Cancel subscription',
  },
}
